import { useQuery, useMutation } from 'react-query';
import { request } from '../utils/axios-utils';

export const getAnglePresets = companyId => {
    return request({
        url: `/anglePreset`,
        method: 'GET',
        params: { companyId },
    });
};

export const getPatternOptions = () => {
    return request({
        url: `/anglePreset/getPatternOptions`,
        method: 'GET',
    });
};

export const useGetPatternOptions = () => {
    return useQuery('getPatternOptions', getPatternOptions, {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
        select: data => data.data,
    });
};

export const useGetAnglePresets = (onSuccess, companyId) => {
    return useQuery(`getAnglePresets${companyId}`, () => getAnglePresets(companyId), {
        onSuccess: onSuccess,
        select: data => data.data,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });
};

export const getAnglePresetById = anglePresetId => {
    return request({
        url: `/anglePreset/${anglePresetId}`,
        method: 'GET',
    });
};

export const useGetAnglePresetById = (onSuccess, anglePresetId) => {
    return useQuery(`getAnglePresetById${anglePresetId}`, () => getAnglePresetById(anglePresetId), {
        onSuccess: onSuccess || undefined,
        enabled: !!anglePresetId,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
        select: data => data.data,
    });
};

const listAnglePresetsLite = companyCode =>
    request({
        url: '/anglePreset/list',
        method: 'GET',
        params: { companyCode },
    });

export const useListAnglePresetsLite = companyCode =>
    useQuery(['anglePresetsLite', companyCode], () => listAnglePresetsLite(companyCode), {
        enabled: !!companyCode,
        select: data => data.data,
        refetchOnWindowFocus: false,
    });

export const updateFinamePattern = async (data, anglePresetId) => {
    return request({
        url: `/anglePreset/${data.anglePresetId}/updateFileNamePattern`,
        method: 'PUT',
        data: { updates: data.updates, ignoreCollitions: data.ignoreCollitions },
    });
};

export const useUpdateFinamePattern = (onSuccess, onError) => {
    return useMutation(updateFinamePattern, {
        onSuccess: onSuccess,
        onError: onError,
    });
};

export const fetchEditGuideline = id => {
    return request({
        // url: `/anglePreset/editingGuidelines/?id=${id}`,
        url: `/anglePreset/guidelines?id=${id}`,
        method: 'GET',
    });
};

export const useFetchEditGuideline = (onSuccess, onError, id) => {
    return useMutation(fetchEditGuideline, {
        onSuccess: onSuccess,
        onError: onError,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });
};
export const updatePresetStatus = data => {
    return request({
        // url: `/anglePreset/editingGuidelines/status`,
        // method: 'PUT',
        url: `/anglePreset/guidelines`,
        method: 'PATCH',
        data: data,
    });
};
export const useUpdatePresetStatus = (onSuccess, onError) => {
    return useMutation(updatePresetStatus, {
        onSuccess: onSuccess,
        onError: onError,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });
};
export const deletePresetGuideline = data => {
    return request({
        // url: `/anglePreset/editingGuidelines/`,
        url: `/anglePreset/guidelines`,
        method: 'DELETE',
        data: data,
    });
};
export const useDeletePresetGuideline = (onSuccess, onError) => {
    return useMutation(deletePresetGuideline, {
        onSuccess: onSuccess,
        onError: onError,
        retry: (failureCount, error) => failureCount < 3 && error?.response?.status !== 401,
    });
};
